import { PUBNUB_HANDLED } from './constants';

export function markPubnubAsDone() {
  return (dispatch) => {
    dispatch({
      type: PUBNUB_HANDLED,
    });
  };
}
